var __defProp = Object.defineProperty;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __assign = Object.assign;
var __name = (target, value) => __defProp(target, "name", {value, configurable: true});
var __rest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/components/ReactiveForm.tsx
import React3 from "react";

// src/components/ReactiveFormProvider.tsx
import React from "react";

// src/components/FormContext.ts
import {createContext} from "react";
var FormContext = createContext(void 0);

// src/components/ReactiveFormProvider.tsx
var ReactiveFormProvider = /* @__PURE__ */ __name(({
  children,
  formBag,
  fallback
}) => {
  if (!formBag.isLoaded) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, fallback);
  }
  return /* @__PURE__ */ React.createElement(FormContext.Provider, {
    value: formBag
  }, children());
}, "ReactiveFormProvider");

// src/hooks/useForm.ts
import {useCallback as useCallback3, useEffect, useMemo, useRef as useRef4, useState as useState2} from "react";
import cloneDeep2 from "lodash/cloneDeep";
import get3 from "lodash/get";
import isEqual2 from "lodash/isEqual";
import merge from "lodash/merge";
import mergeWith from "lodash/mergeWith";
import {getOrReturn as getOrReturn2} from "stocked";
import invariant4 from "tiny-invariant";

// src/hooks/useFormControl.ts
import {useStock} from "stocked";

// src/hooks/useControlHandlers.ts
var useControlHandlers = /* @__PURE__ */ __name(({
  values,
  errors,
  touched,
  formMeta
}) => {
  const {setValue: setFormMeta, getValue: getFormMeta} = formMeta;
  const {setValue: setFieldValue, getValue: getFieldValue, setValues} = values;
  const {setValue: setFieldTouched, getValue: getFieldTouched, setValues: setTouched} = touched;
  const {setValue: setFieldError, getValue: getFieldError, setValues: setErrors} = errors;
  return {
    setFormMeta,
    getFormMeta,
    setFieldValue,
    getFieldValue,
    setValues,
    setFieldTouched,
    getFieldTouched,
    setTouched,
    setFieldError,
    getFieldError,
    setErrors
  };
}, "useControlHandlers");

// src/hooks/useFormControl.ts
var initialFormMeta = {
  dirty: false,
  isSubmitting: false,
  isValid: true,
  isValidating: false,
  submitCount: 0
};
var useFormControl = /* @__PURE__ */ __name(({
  initialValues,
  initialErrors,
  initialTouched
}) => {
  const values = useStock({initialValues});
  const errors = useStock({initialValues: initialErrors});
  const touched = useStock({initialValues: initialTouched});
  const formMeta = useStock({initialValues: initialFormMeta});
  const handlers = useControlHandlers({values, errors, touched, formMeta});
  return __assign(__assign({}, handlers), {
    formMeta,
    errors,
    touched,
    values
  });
}, "useFormControl");

// src/hooks/usePlugins.ts
import {useContext} from "react";

// src/components/FormPlugins.tsx
import React2, {createContext as createContext2, useRef} from "react";
import invariant from "tiny-invariant";
var FormPluginsContext = createContext2([]);
var FormPlugins = /* @__PURE__ */ __name(({plugins, children}) => {
  const tokenRef = useRef();
  if (tokenRef.current === void 0) {
    tokenRef.current = plugins.token;
  }
  invariant(tokenRef.current === plugins.token, "PluginArray token have changed. This means that you've modified your plugins runtime. PluginArray should never be modified / updated / extended.");
  return /* @__PURE__ */ React2.createElement(FormPluginsContext.Provider, {
    value: plugins.plugins
  }, children);
}, "FormPlugins");

// src/hooks/usePlugins.ts
var usePlugins = /* @__PURE__ */ __name((bag, config) => {
  const plugins = useContext(FormPluginsContext);
  for (const plugin of plugins) {
    bag = plugin.useDecorator(bag, config);
  }
  return bag;
}, "usePlugins");

// src/hooks/useValidationRegistry.ts
import {useCallback, useRef as useRef2} from "react";
import get from "lodash/get";
import set from "lodash/set";
import {getOrReturn, isInnerPath, longestCommonPath, normalizePath, setOrReturn} from "stocked";
import invariant3 from "tiny-invariant";

// src/utils/FunctionArray.ts
import invariant2 from "tiny-invariant";
var FunctionArray = class {
  constructor() {
    this.items = [];
    this.call = /* @__PURE__ */ __name((...args) => {
      return this.items.map((func) => func(...args));
    }, "call");
    this.lazyCall = /* @__PURE__ */ __name((...args) => {
      for (const item of this.items) {
        const output = item(...args);
        if (output !== null && output !== void 0 && output !== void 0) {
          return output;
        }
      }
      return void 0;
    }, "lazyCall");
    this.asyncCall = /* @__PURE__ */ __name(async (...args) => {
      return Promise.all(this.items.map(async (func) => await func(...args)));
    }, "asyncCall");
    this.lazyAsyncCall = /* @__PURE__ */ __name(async (...args) => {
      for (const item of this.items) {
        const output = await item(...args);
        if (output !== null && output !== void 0 && output !== void 0) {
          return output;
        }
      }
      return void 0;
    }, "lazyAsyncCall");
    this.push = /* @__PURE__ */ __name((func) => {
      this.items.push(func);
    }, "push");
    this.remove = /* @__PURE__ */ __name((func) => {
      const index = this.items.indexOf(func);
      invariant2(index !== -1, "Could not remove, because function does not exist in array.");
      this.items.splice(index, 1);
    }, "remove");
    this.isEmpty = /* @__PURE__ */ __name(() => this.items.length === 0, "isEmpty");
  }
};
__name(FunctionArray, "FunctionArray");

// src/utils/validatorResultToError.ts
var validatorResultToError = /* @__PURE__ */ __name((result) => {
  if (typeof result !== "object" || result === null) {
    return {
      $error: typeof result === "string" ? result : void 0
    };
  }
  return result;
}, "validatorResultToError");

// src/hooks/useValidationRegistry.ts
var useValidationRegistry = /* @__PURE__ */ __name(() => {
  const registry = useRef2({});
  const registerValidator = useCallback((name, validator) => {
    name = normalizePath(name);
    if (!Object.prototype.hasOwnProperty.call(registry.current, name)) {
      registry.current[name] = new FunctionArray();
    }
    registry.current[name].push(validator);
    return () => {
      const currentValidators = registry.current[name];
      invariant3(currentValidators, "Cannot unregister field validator on field, which was not registered");
      currentValidators.remove(validator);
      if (currentValidators.isEmpty())
        delete registry.current[name];
    };
  }, []);
  const validateField = useCallback(async (name, value) => {
    name = normalizePath(name);
    if (Object.prototype.hasOwnProperty.call(registry.current, name)) {
      const output = await registry.current[name].lazyAsyncCall(value);
      return validatorResultToError(output);
    }
    return void 0;
  }, []);
  const hasValidator = useCallback((name) => Object.prototype.hasOwnProperty.call(registry.current, normalizePath(name)), []);
  const validateBranch = useCallback(async (origin, values) => {
    origin = normalizePath(origin);
    const pathsToValidate = Object.keys(registry.current).filter((i) => isInnerPath(origin, i) || isInnerPath(i, origin) || i === origin).sort((a, b) => a.length - b.length);
    let errors = {};
    for (const path of pathsToValidate) {
      const error = await validateField(path, getOrReturn(values, path));
      errors = setOrReturn(errors, path, error);
    }
    return {attachPath: longestCommonPath(pathsToValidate), errors};
  }, [validateField]);
  const validateAllFields = useCallback(async (values) => {
    const reducedErrors = {};
    const allValidatorKeys = Object.keys(registry.current).sort((a, b) => a.length - b.length);
    for (const key of allValidatorKeys) {
      const error = await registry.current[key].lazyAsyncCall(get(values, key));
      if (error) {
        set(reducedErrors, key, validatorResultToError(error));
      }
    }
    return reducedErrors;
  }, []);
  return {
    registerValidator,
    validateField,
    validateAllFields,
    hasValidator,
    validateBranch
  };
}, "useValidationRegistry");

// src/utils/deepRemoveEmpty.ts
import isEmpty from "lodash/isEmpty";
import isNil from "lodash/isNil";
var deepRemoveEmpty = /* @__PURE__ */ __name((obj) => {
  if (Array.isArray(obj)) {
    const newArr = Object.assign([], Object.fromEntries(Object.entries(obj).map(([key, value]) => [
      key,
      typeof value === "object" ? deepRemoveEmpty(value) : value
    ])));
    return Object.values(newArr).every(isNil) ? void 0 : newArr;
  } else if (obj !== null && typeof obj === "object") {
    const newObj = Object.keys(obj).reduce((acc, key) => {
      const value = typeof obj[key] === "object" ? deepRemoveEmpty(obj[key]) : obj[key];
      if (!isNil(value)) {
        acc[key] = value;
      }
      return acc;
    }, {});
    return isEmpty(newObj) ? void 0 : newObj;
  }
  return void 0;
}, "deepRemoveEmpty");

// src/utils/excludeOverlaps.ts
import unset from "lodash/unset";
import {ROOT_PATH as ROOT_PATH5} from "stocked";

// src/utils/getDifferenceMap.ts
import isEqual from "lodash/isEqual";
import uniq from "lodash/uniq";
import {ROOT_PATH as ROOT_PATH4} from "stocked";

// src/utils/flattenObject.ts
import {ROOT_PATH as ROOT_PATH3} from "stocked";

// src/utils/joinPaths.ts
import isNil2 from "lodash/isNil";
import {ROOT_PATH as ROOT_PATH2} from "stocked";
var joinPaths = /* @__PURE__ */ __name((...parts) => parts.filter((part) => !isNil2(part) && part !== false && part !== ROOT_PATH2).join("."), "joinPaths");

// src/utils/flattenObject.ts
var flattenObject = /* @__PURE__ */ __name((obj) => {
  const queue = [[ROOT_PATH3, obj]];
  const result = {};
  while (queue.length) {
    const [pathToObject, innerObject] = queue.shift();
    for (const key in innerObject) {
      const item = innerObject[key];
      const pathToItem = joinPaths(pathToObject, key);
      if (typeof item !== "object" || item === null || Object.keys(item).length === 0) {
        result[pathToItem] = item;
      } else {
        queue.push([pathToItem, item]);
      }
    }
  }
  return result;
}, "flattenObject");

// src/utils/getDifferenceMap.ts
var nearestChild = /* @__PURE__ */ __name((parentPath, comparePath) => {
  const indexOfDot = comparePath.indexOf(".", parentPath === ROOT_PATH4 ? 0 : parentPath.length + 1);
  return indexOfDot === -1 ? comparePath : comparePath.substring(0, indexOfDot);
}, "nearestChild");
var isInnerPath2 = /* @__PURE__ */ __name((parent, child) => {
  if (parent === ROOT_PATH4) {
    return true;
  }
  if (parent === "") {
    return child[0] === ".";
  }
  return child.indexOf(parent + ".") === 0;
}, "isInnerPath");
var getDifferenceMap = /* @__PURE__ */ __name((obj1, obj2) => {
  var _a;
  const flattenedObj1 = flattenObject(obj1);
  const flattenedObj2 = flattenObject(obj2);
  if (Object.keys(flattenedObj1).length === 0 && Object.keys(flattenedObj2).length === 0) {
    return {[ROOT_PATH4]: true};
  }
  if (Object.keys(flattenedObj1).length === 0 || Object.keys(flattenedObj2).length === 0) {
    return {[ROOT_PATH4]: false};
  }
  const rawDiffMap = {};
  Object.keys(flattenedObj1).forEach((key) => rawDiffMap[key] = isEqual(flattenedObj1[key], flattenedObj2[key]));
  const diffMap = {};
  const pathQueue = [ROOT_PATH4];
  while (pathQueue.length) {
    const curPath = pathQueue.shift();
    const innerPaths = Object.keys(rawDiffMap).filter((innerPath) => isInnerPath2(curPath, innerPath));
    if (innerPaths.every((innerPath, index, arr) => index === 0 || rawDiffMap[innerPath] === rawDiffMap[arr[index - 1]])) {
      diffMap[curPath] = rawDiffMap[(_a = innerPaths[0]) != null ? _a : curPath];
    } else {
      pathQueue.push(...uniq(innerPaths.map((innerPath) => nearestChild(curPath, innerPath))));
    }
  }
  return diffMap;
}, "getDifferenceMap");

// src/utils/excludeOverlaps.ts
var excludeOverlaps = /* @__PURE__ */ __name((source, compare, exclusionObject) => {
  const diffMap = getDifferenceMap(source, compare);
  if (diffMap[ROOT_PATH5])
    return {};
  if (diffMap[ROOT_PATH5] === false)
    return exclusionObject;
  Object.keys(diffMap).sort((a, b) => a.length - b.length).forEach((key) => {
    if (diffMap[key]) {
      unset(exclusionObject, key);
    }
  });
  return exclusionObject;
}, "excludeOverlaps");

// src/utils/loadingGuard.ts
var notLoadedError = /* @__PURE__ */ __name((name) => `${name} is not loaded yet. You probably forgot to use fallback, or check using "isLoaded" property.`, "notLoadedError");
var notLoadedFn = /* @__PURE__ */ __name((name) => () => {
  throw new Error(notLoadedError(name));
}, "notLoadedFn");
var getErrorHandler = /* @__PURE__ */ __name((name) => {
  const fn = notLoadedFn(name);
  return {
    get: fn,
    set: fn,
    deleteProperty: fn,
    has: fn,
    defineProperty: fn,
    ownKeys: fn
  };
}, "getErrorHandler");
var defaultNotLoadedFn = notLoadedFn("Object");
var guardHandler = {
  get: (target, path) => {
    const value = target[path];
    if (typeof value === "function") {
      return notLoadedFn(path.toString());
    } else if (typeof value === "object" && value !== null) {
      return new Proxy(value, getErrorHandler(path.toString()));
    }
    return value;
  },
  set: defaultNotLoadedFn,
  deleteProperty: defaultNotLoadedFn,
  has: defaultNotLoadedFn,
  defineProperty: defaultNotLoadedFn,
  ownKeys: defaultNotLoadedFn
};
var loadingGuard = /* @__PURE__ */ __name((value, isLoaded) => {
  return isLoaded ? value : new Proxy(value, guardHandler);
}, "loadingGuard");

// src/utils/overrideMerge.ts
import cloneDeep from "lodash/cloneDeep";
import isObject from "lodash/isObject";
var overrideMerge = /* @__PURE__ */ __name((object, source) => {
  object = cloneDeep(object);
  const queue = [[object, source]];
  while (queue.length) {
    const [currentObject, currentSource] = queue.shift();
    Object.entries(currentSource).forEach(([key, value]) => {
      if (!(key in currentObject)) {
        currentObject[key] = cloneDeep(value);
        return;
      }
      const compareValue = currentObject[key];
      const compareSourceValue = currentSource[key];
      if (isObject(compareValue) && isObject(compareSourceValue)) {
        queue.push([compareValue, compareSourceValue]);
      } else {
        currentObject[key] = cloneDeep(currentSource[key]);
      }
    });
  }
  return object;
}, "overrideMerge");

// src/utils/isYupError.ts
var isYupError = /* @__PURE__ */ __name((value) => {
  return !!value && value.name === "ValidationError";
}, "isYupError");

// src/utils/yupToFormErrors.ts
import get2 from "lodash/get";
import set2 from "lodash/set";
import toPath from "lodash/toPath";

// src/constants.ts
var REACTIVE_FORMS_PREFIX = "$";
var REACTIVE_FORMS_ERROR_PREFIX = `${REACTIVE_FORMS_PREFIX}error`;
var getErrorPath = /* @__PURE__ */ __name((path) => path ? `${path}.${REACTIVE_FORMS_ERROR_PREFIX}` : REACTIVE_FORMS_ERROR_PREFIX, "getErrorPath");

// src/utils/yupToFormErrors.ts
var yupToFormErrors = /* @__PURE__ */ __name((yupError) => {
  var _a;
  const isArr = (_a = yupError.inner) == null ? void 0 : _a.some((value) => !isNaN(+toPath(value.path)[0]));
  const errors = isArr ? [] : {};
  if (yupError.inner) {
    if (yupError.inner.length === 0) {
      set2(errors, getErrorPath(yupError.path), yupError.message);
    }
    for (const error of yupError.inner) {
      if (!get2(errors, error.path || "")) {
        set2(errors, getErrorPath(error.path), error.message);
      }
    }
  }
  return errors;
}, "yupToFormErrors");

// src/utils/runYupSchema.ts
var runYupSchema = /* @__PURE__ */ __name(async (schema, value, options) => {
  try {
    await schema.validate(value, options);
  } catch (error) {
    if (isYupError(error)) {
      return yupToFormErrors(error);
    } else {
      throw error;
    }
  }
  return void 0;
}, "runYupSchema");

// src/utils/setNestedValues.ts
import isObject2 from "lodash/isObject";
var setNestedValues = /* @__PURE__ */ __name((exampleObject, value, visited = new WeakMap(), output = {}) => Object.keys(exampleObject).reduce((acc, key) => {
  const part = exampleObject[key];
  if (isObject2(part)) {
    if (!visited.get(part)) {
      visited.set(part, true);
      acc[key] = Array.isArray(part) ? [] : {};
      acc[key] = Object.assign(acc[key], value);
      setNestedValues(part, value, visited, acc[key]);
    }
  } else {
    acc[key] = value;
  }
  return acc;
}, output), "setNestedValues");

// src/utils/useRefCallback.ts
import {useCallback as useCallback2, useRef as useRef3} from "react";
var useRefCallback = /* @__PURE__ */ __name((func) => {
  const ref = useRef3(func);
  ref.current = func;
  const callback = useCallback2((...args) => {
    var _a;
    return (_a = ref.current) == null ? void 0 : _a.call(ref, ...args);
  }, []);
  return callback;
}, "useRefCallback");

// src/utils/useThrowError.ts
import {useState} from "react";
var NO_ERROR_SYMBOL = Symbol();
var useThrowError = /* @__PURE__ */ __name(() => {
  const [error, setError] = useState(NO_ERROR_SYMBOL);
  if (error !== NO_ERROR_SYMBOL) {
    throw error;
  }
  return setError;
}, "useThrowError");

// src/hooks/useForm.ts
var deepCustomizer = /* @__PURE__ */ __name((src1, src2) => {
  const filtered = [src1, src2].filter((a) => typeof a === "object" && a !== null);
  if (filtered.length === 1) {
    return filtered[0];
  }
}, "deepCustomizer");
var useForm = /* @__PURE__ */ __name((config) => {
  const throwError = useThrowError();
  const {schema, disablePureFieldsValidation} = config;
  const onSubmit = useRefCallback(config.onSubmit);
  const validateFormFn = useRefCallback(config.validateForm);
  const onValidationFailed = useRefCallback(config.onValidationFailed);
  const onValidationSucceed = useRefCallback(config.onValidationSucceed);
  const onReset = useRefCallback(config.onReset);
  const {
    initialValues = {},
    initialErrors = {},
    initialTouched = {}
  } = config.load ? {
    initialValues: void 0,
    initialErrors: void 0,
    initialTouched: void 0
  } : config;
  const control = useFormControl({initialValues, initialErrors, initialTouched});
  const {
    validateField: runFieldLevelValidation,
    validateAllFields,
    hasValidator,
    validateBranch,
    registerValidator
  } = useValidationRegistry();
  const initialValuesRef = useRef4(initialValues);
  const initialErrorsRef = useRef4(initialErrors);
  const initialTouchedRef = useRef4(initialTouched);
  const isPending = useRef4(false);
  const {setFieldError, setErrors, setTouched, setValues, setFormMeta, getFormMeta, values, errors} = control;
  const loadRef = useRef4(config.load);
  loadRef.current = config.load;
  const [isLoaded, setIsLoaded] = useState2(!config.load);
  const validateField = useCallback3(async (name, value) => {
    if (hasValidator(name)) {
      if (!disablePureFieldsValidation || !isEqual2(value, get3(initialValuesRef.current, name))) {
        const error = await runFieldLevelValidation(name, value);
        setFieldError(name, (old) => __assign(__assign({}, old), error));
        return error;
      } else {
        setFieldError(name, void 0);
      }
    }
    return void 0;
  }, [runFieldLevelValidation, setFieldError, hasValidator, disablePureFieldsValidation]);
  const runFormValidationSchema = useCallback3((values2) => {
    if (!schema)
      return Promise.resolve(void 0);
    return runYupSchema(schema, values2);
  }, [schema]);
  const validateForm = useCallback3(async (values2) => {
    var _a;
    const registryErrors = await validateAllFields(values2);
    const validateFormFnErrors = validatorResultToError(await (validateFormFn == null ? void 0 : validateFormFn(values2)));
    const schemaErrors = await runFormValidationSchema(values2);
    const allErrors = (_a = deepRemoveEmpty(merge({}, registryErrors, validateFormFnErrors, schemaErrors))) != null ? _a : {};
    if (!disablePureFieldsValidation) {
      return allErrors;
    } else {
      return excludeOverlaps(values2, initialValuesRef.current, allErrors);
    }
  }, [runFormValidationSchema, validateAllFields, validateFormFn, disablePureFieldsValidation]);
  const resetForm = useCallback3((initialFormState) => {
    var _a, _b, _c;
    const nonNullableFormState = {
      initialValues: (_a = initialFormState == null ? void 0 : initialFormState.initialValues) != null ? _a : initialValuesRef.current,
      initialTouched: (_b = initialFormState == null ? void 0 : initialFormState.initialTouched) != null ? _b : initialTouchedRef.current,
      initialErrors: (_c = initialFormState == null ? void 0 : initialFormState.initialErrors) != null ? _c : initialErrorsRef.current
    };
    const {initialErrors: initialErrors2, initialTouched: initialTouched2, initialValues: initialValues2} = nonNullableFormState;
    setValues(cloneDeep2(initialValues2));
    setTouched(cloneDeep2(initialTouched2));
    setErrors(cloneDeep2(initialErrors2));
    initialValuesRef.current = initialValues2;
    initialErrorsRef.current = initialErrors2;
    initialTouchedRef.current = initialTouched2;
    onReset(nonNullableFormState);
  }, [setValues, setTouched, setErrors, onReset]);
  const helpers = useMemo(() => __assign(__assign({}, control), {
    validateField,
    validateForm,
    resetForm
  }), [control, resetForm, validateField, validateForm]);
  const submit = useCallback3(async (action) => {
    if (typeof action !== "function") {
      action = onSubmit;
    }
    invariant4(action, "Cannot call submit, because no action specified in arguments and no default action provided.");
    setFormMeta("submitCount", getFormMeta("submitCount") + 1);
    setFormMeta("isSubmitting", true);
    setFormMeta("isValidating", true);
    const currentValues = values.getValues();
    const newErrors = await validateForm(currentValues);
    setFormMeta("isValidating", false);
    setErrors(newErrors);
    setTouched(setNestedValues(mergeWith({}, cloneDeep2(currentValues), cloneDeep2(initialValuesRef.current), deepCustomizer), {
      $touched: true
    }));
    try {
      if (Object.keys(newErrors).length === 0) {
        onValidationSucceed == null ? void 0 : onValidationSucceed();
        await action(currentValues, helpers);
      } else {
        onValidationFailed == null ? void 0 : onValidationFailed(newErrors);
      }
    } finally {
      setFormMeta("isSubmitting", false);
    }
  }, [
    onSubmit,
    setFormMeta,
    getFormMeta,
    values,
    validateForm,
    setErrors,
    setTouched,
    onValidationFailed,
    helpers,
    onValidationSucceed
  ]);
  const updateFormDirtiness = useCallback3(({values: values2}) => setFormMeta("dirty", !isEqual2(values2, initialValuesRef.current)), [setFormMeta]);
  const updateFormValidness = useCallback3(({values: values2}) => setFormMeta("isValid", deepRemoveEmpty(values2) === void 0), [setFormMeta]);
  const validateUpdatedFields = useCallback3(async ({values: values2, origin}) => {
    const {attachPath, errors: errors2} = await validateBranch(origin, values2);
    const onlyNecessaryErrors = getOrReturn2(errors2, attachPath);
    const normalizedErrors = disablePureFieldsValidation ? merge(setNestedValues(onlyNecessaryErrors, void 0), excludeOverlaps(values2, getOrReturn2(initialValuesRef.current, attachPath), onlyNecessaryErrors)) : onlyNecessaryErrors;
    setFieldError(attachPath, (old) => overrideMerge(old != null ? old : {}, normalizedErrors));
  }, [disablePureFieldsValidation, setFieldError, validateBranch]);
  useEffect(() => values.watchBatchUpdates(updateFormDirtiness), [values, updateFormDirtiness]);
  useEffect(() => errors.watchBatchUpdates((batchUpdate) => {
    if (batchUpdate.paths.length > 0) {
      updateFormValidness(batchUpdate);
    }
  }), [errors, updateFormValidness]);
  useEffect(() => values.watchBatchUpdates(validateUpdatedFields), [values, validateUpdatedFields]);
  useEffect(() => {
    if (loadRef.current && !isPending.current && !isLoaded) {
      isPending.current = true;
      loadRef.current().then(resetForm).catch(throwError).finally(() => {
        setIsLoaded(true);
        isPending.current = false;
      });
    }
  }, [resetForm, throwError, isLoaded]);
  const bag = __assign({
    submit,
    resetForm,
    validateField,
    validateForm,
    hasValidator,
    registerValidator,
    isLoaded
  }, control);
  const bagWithPlugins = usePlugins(bag, config);
  return loadingGuard(bagWithPlugins, isLoaded);
}, "useForm");

// src/components/ReactiveForm.tsx
var ReactiveForm = /* @__PURE__ */ __name((_a) => {
  var {
    children,
    fallback
  } = _a, config = __rest(_a, [
    "children",
    "fallback"
  ]);
  const formBag = useForm(config);
  return /* @__PURE__ */ React3.createElement(ReactiveFormProvider, {
    fallback,
    formBag
  }, children);
}, "ReactiveForm");

// src/components/Field.tsx
import React4 from "react";

// src/hooks/useFieldError.ts
import {useStockState} from "stocked";

// src/hooks/useFormContext.ts
import {useContext as useContext2} from "react";
import invariant5 from "tiny-invariant";
var useFormContext = /* @__PURE__ */ __name(() => {
  const context = useContext2(FormContext);
  invariant5(context, "You're trying to access FormContext outside <ReactiveForm> tag");
  return context;
}, "useFormContext");

// src/hooks/useFieldError.ts
var useFieldError = /* @__PURE__ */ __name((name) => {
  const {errors} = useFormContext();
  return useStockState(name, errors);
}, "useFieldError");

// src/hooks/useFieldTouched.ts
import {useStockState as useStockState2} from "stocked";
var useFieldTouched = /* @__PURE__ */ __name((name) => {
  const {touched} = useFormContext();
  return useStockState2(name, touched);
}, "useFieldTouched");

// src/hooks/useFieldValidator.ts
import {useEffect as useEffect2, useRef as useRef5} from "react";
import merge2 from "lodash/merge";
var useFieldValidator = /* @__PURE__ */ __name(({name, validator: validatorFn, schema}) => {
  const {registerValidator} = useFormContext();
  const validate = /* @__PURE__ */ __name(async (value) => {
    if (!validatorFn && !schema)
      return void 0;
    const validatorErrors = await (validatorFn == null ? void 0 : validatorFn(value));
    const schemaErrors = schema ? await runYupSchema(schema, value) : void 0;
    if (!schemaErrors)
      return validatorErrors;
    return merge2(schemaErrors, validatorErrors);
  }, "validate");
  const validateRef = useRef5(validate);
  validateRef.current = validate;
  useEffect2(() => {
    const validator = /* @__PURE__ */ __name((value) => {
      var _a;
      return (_a = validateRef.current) == null ? void 0 : _a.call(validateRef, value);
    }, "validator");
    return registerValidator(name, validator);
  }, [name, registerValidator]);
}, "useFieldValidator");

// src/hooks/useFieldValue.ts
import {useStockState as useStockState3} from "stocked";
var useFieldValue = /* @__PURE__ */ __name((name) => {
  const {values} = useFormContext();
  return useStockState3(name, values);
}, "useFieldValue");

// src/hooks/useField.ts
var useField = /* @__PURE__ */ __name(({name, validator, schema}) => {
  const [value, setValue] = useFieldValue(name);
  const [touched, setTouched] = useFieldTouched(name);
  const [error, setError] = useFieldError(name);
  useFieldValidator({name, validator, schema});
  return {
    value,
    meta: {
      error,
      touched
    },
    control: {
      setValue,
      setTouched,
      setError
    }
  };
}, "useField");

// src/components/Field.tsx
var Field = /* @__PURE__ */ __name((_a) => {
  var {children} = _a, config = __rest(_a, ["children"]);
  const bag = useField(config);
  return /* @__PURE__ */ React4.createElement(React4.Fragment, null, children(bag));
}, "Field");

// src/components/ReactiveFormConsumer.tsx
import React5 from "react";
var ReactiveFormConsumer = /* @__PURE__ */ __name(({children}) => {
  const shared = useFormContext();
  return /* @__PURE__ */ React5.createElement(React5.Fragment, null, children(shared));
}, "ReactiveFormConsumer");

// src/components/FormProxyProvider.tsx
import React6, {createContext as createContext3, useCallback as useCallback4} from "react";
import {intercept, useStockContext} from "stocked";
var FormProxyContext = createContext3(void 0);
var FormProxyProvider = /* @__PURE__ */ __name(({proxy, children}) => {
  const _a = useFormContext(), {values, errors, touched, formMeta, registerValidator} = _a, other = __rest(_a, ["values", "errors", "touched", "formMeta", "registerValidator"]);
  const newValues = useStockContext(values, proxy);
  const newErrors = useStockContext(errors, proxy);
  const newTouched = useStockContext(touched, proxy);
  const handlers = useControlHandlers({values: newValues, errors: newErrors, touched: newTouched, formMeta});
  const {getFieldValue} = handlers;
  const interceptedRegisterValidator = useCallback4((name, validator) => intercept(proxy, name, registerValidator, (name2, validator2) => {
    return registerValidator(proxy.getNormalPath(name2), () => validator2(getFieldValue(name2)));
  }, [name, validator]), [getFieldValue, proxy, registerValidator]);
  return /* @__PURE__ */ React6.createElement(FormContext.Provider, {
    value: __assign(__assign(__assign({}, other), handlers), {
      formMeta,
      values: newValues,
      errors: newErrors,
      touched: newTouched,
      registerValidator: interceptedRegisterValidator
    })
  }, /* @__PURE__ */ React6.createElement(FormProxyContext.Provider, {
    value: proxy
  }, children));
}, "FormProxyProvider");

// src/hooks/useArrayControl.ts
var useArrayControl = /* @__PURE__ */ __name(({name}) => {
  const {setFieldValue, setFieldTouched, setFieldError, getFieldValue, getFieldError, getFieldTouched} = useFormContext();
  const setItems = /* @__PURE__ */ __name((items) => setFieldValue(name, items), "setItems");
  const setTouched = /* @__PURE__ */ __name((newTouched) => setFieldTouched(name, newTouched), "setTouched");
  const setErrors = /* @__PURE__ */ __name((newErrors) => setFieldError(name, newErrors), "setErrors");
  const updateArray = /* @__PURE__ */ __name((update, updateErrors, updateTouched) => {
    const items = getFieldValue(name);
    const errors = getFieldError(name);
    const touched = getFieldTouched(name);
    const [newItems, output] = update(items);
    setItems(newItems);
    if (updateErrors && Array.isArray(errors)) {
      setErrors(typeof updateErrors === "function" ? updateErrors(errors, items) : update(errors)[0]);
    }
    if (updateTouched && Array.isArray(touched)) {
      setTouched(typeof updateTouched === "function" ? updateTouched(touched, items) : update(touched)[0]);
    }
    return output;
  }, "updateArray");
  const setItem = useRefCallback((item, index) => updateArray((items) => {
    items[index] = item;
    return [items, void 0];
  }, false, false));
  const push = useRefCallback((...newItems) => updateArray((oldItems) => {
    const size = oldItems.push(...newItems);
    return [oldItems, size];
  }, false, false));
  const pop = useRefCallback(() => updateArray((oldItems) => {
    const output = oldItems.pop();
    return [oldItems, output];
  }, (errors, items) => {
    const index = items.length;
    errors.splice(index);
    return errors;
  }, (touched, items) => {
    const index = items.length;
    touched.splice(index);
    return touched;
  }));
  const removeAt = useRefCallback((index) => updateArray((items) => {
    items.splice(index, 1);
    return [items, void 0];
  }, true, true));
  const swap = useRefCallback((first, second) => updateArray((items) => {
    const a = items[first];
    items[first] = items[second];
    items[second] = a;
    return [items, void 0];
  }, true, true));
  const shift = useRefCallback(() => updateArray((items) => {
    const shiftedItem = items.shift();
    return [items, shiftedItem];
  }, true, true));
  const unshift = useRefCallback((newItem) => updateArray((items) => {
    const newArrayLength = items.unshift(newItem);
    return [items, newArrayLength];
  }, (oldErrors) => {
    oldErrors.unshift(void 0);
    return oldErrors;
  }, (oldTouched) => {
    oldTouched.unshift(void 0);
    return oldTouched;
  }));
  const move = useRefCallback((from, to) => updateArray((items) => {
    const item = items[from];
    if (items.length <= to) {
      items.push(...new Array(to - items.length + 1));
    }
    items.splice(from, 1);
    items.splice(to, 0, item);
    return [items, void 0];
  }, true, true));
  const insert = useRefCallback((index, value) => updateArray((items) => {
    items.splice(index, 0, value);
    return [items, void 0];
  }, (oldErrors) => {
    oldErrors.splice(index, 0, void 0);
    return oldErrors;
  }, (oldTouched) => {
    oldTouched.splice(index, 0, void 0);
    return oldTouched;
  }));
  return {
    setItems,
    setItem,
    push,
    pop,
    removeAt,
    swap,
    shift,
    unshift,
    move,
    insert
  };
}, "useArrayControl");

// src/hooks/useArrayField.ts
var useArrayField = /* @__PURE__ */ __name((_a) => {
  var fieldContextConfig = __rest(_a, []);
  const {
    value: items,
    meta: {error: errors, touched}
  } = useField(fieldContextConfig);
  const {name} = fieldContextConfig;
  const control = useArrayControl({name});
  return __assign({
    items,
    name,
    errors,
    touched
  }, control);
}, "useArrayField");

// src/hooks/useFormMeta.ts
import {useStockValue} from "stocked";
var useFormMeta = /* @__PURE__ */ __name((name) => {
  const {formMeta} = useFormContext();
  return useStockValue(name, formMeta);
}, "useFormMeta");

// src/hooks/useObjectField.ts
import {useCallback as useCallback5} from "react";
import set3 from "lodash/set";
var useObjectField = /* @__PURE__ */ __name((contextConfig) => {
  const {
    value: values,
    control: {setValue: setValues, setTouched, setError: setErrors},
    meta: {error: errors, touched}
  } = useField(contextConfig);
  const setDeepValue = useCallback5((path, value) => setValues(set3(values, path, value)), [setValues, values]);
  const setDeepTouched = useCallback5((path, newTouched) => setTouched(set3(touched != null ? touched : {}, path, newTouched)), [setTouched, touched]);
  const setDeepError = useCallback5((path, error) => setErrors(set3(errors != null ? errors : {}, path, error)), [errors, setErrors]);
  return {
    values,
    errors,
    touched,
    setValues,
    setErrors,
    setTouched,
    setDeepError,
    setDeepTouched,
    setDeepValue
  };
}, "useObjectField");

// src/hooks/useSubmitAction.ts
import {useCallback as useCallback6} from "react";
var useSubmitAction = /* @__PURE__ */ __name((action) => {
  const {submit} = useFormContext();
  const realSubmit = useCallback6(() => submit(action), [action, submit]);
  return realSubmit;
}, "useSubmitAction");

// src/hooks/usePluginAssertion.ts
import {useContext as useContext3} from "react";
import invariant6 from "tiny-invariant";
var usePluginAssertion = /* @__PURE__ */ __name((plugin, message) => {
  const plugins = useContext3(FormPluginsContext);
  invariant6(plugins.some((it) => it.token === plugin.token), message);
}, "usePluginAssertion");

// src/hooks/useFieldValueArray.ts
import {useEffect as useEffect3, useState as useState3} from "react";
var useFieldValueArray = /* @__PURE__ */ __name((paths) => {
  const {
    values: {watch},
    getFieldValue
  } = useFormContext();
  const [object, setObject] = useState3(() => Object.entries(paths).reduce((acc, [to, from]) => {
    acc[to] = getFieldValue(from);
    return acc;
  }, {}));
  useEffect3(() => {
    const cleanups = Object.entries(paths).map(([to, from]) => watch(from, (value) => {
      setObject((prev) => __assign(__assign({}, prev), {
        [to]: value
      }));
    }));
    return () => cleanups.forEach((cleanup) => cleanup());
  }, [...Object.keys(paths), ...Object.values(paths), watch]);
  return object;
}, "useFieldValueArray");

// src/typings/PluginArray.ts
var createPluginArray = /* @__PURE__ */ __name((...plugins) => {
  const object = {
    token: Symbol(),
    plugins: Object.freeze(plugins.map(Object.freeze))
  };
  return Object.freeze(object);
}, "createPluginArray");
export {
  Field,
  FormPlugins,
  FormPluginsContext,
  FormProxyContext,
  FormProxyProvider,
  ReactiveFormConsumer,
  ReactiveFormProvider,
  createPluginArray,
  ReactiveForm as default,
  useArrayControl,
  useArrayField,
  useField,
  useFieldError,
  useFieldTouched,
  useFieldValidator,
  useFieldValue,
  useFieldValueArray,
  useForm,
  useFormContext,
  useFormMeta,
  useObjectField,
  usePluginAssertion,
  useSubmitAction,
  useValidationRegistry
};
